import React from "react";
import clsx from "clsx";

// Text-based GovX wordmark — never boxed, adapts to light/dark backgrounds.
// variant: "light" for dark backgrounds, "dark" for light backgrounds.
export const GovXLogo = ({ variant = "dark", className = "", showSub = true }) => {
  const gov = variant === "light" ? "text-govx-paper" : "text-govx-charcoal";
  const sub = variant === "light" ? "text-govx-grey" : "text-govx-green";
  return (
    <span className={clsx("inline-flex select-none flex-col leading-none", className)}>
      <span className="font-display text-[1.6rem] font-extrabold tracking-tight sm:text-[1.75rem]">
        <span className={gov}>Gov</span>
        <span className="bg-gradient-to-br from-govx-green to-govx-lime bg-clip-text text-transparent">X</span>
        <sup className={clsx("ml-0.5 align-super text-[0.5rem] font-semibold", sub)}>®</sup>
      </span>
      {showSub && (
        <span className={clsx("mt-1 font-mono text-[0.5rem] font-semibold uppercase tracking-[0.4em]", sub)}>
          Nigeria
        </span>
      )}
    </span>
  );
};
